import { resolveTenantSlug } from './resolve'
import { readTenantSlugCookie } from './tenant-cookie'

let _slug: string | null | undefined = undefined

/**
 * O slug que o edge resolveu no Global Config vence o host: o rótulo do
 * subdomínio não é o slug do evento, e adivinhar por ele abria o evento de
 * outro cliente. O host só decide sem cookie — em dev, onde o middleware não
 * roda.
 */
export function getCurrentTenantSlug(): string | null {
  if (_slug === undefined) {
    _slug = typeof window !== 'undefined'
      ? readTenantSlugCookie(document.cookie) ??
        resolveTenantSlug(window.location.host)
      : null
  }
  return _slug
}

export function resetTenantSlugForTests() {
  _slug = undefined
}
